<h1 class="pb-2 border-bottom fw-light" i18n>Offene Anfragen</h1>

<kendo-grid
  [data]="nonProfileUsers"
  [sortable]="true"
  [reorderable]="true"
  [resizable]="true"
>
  <ng-template kendoGridNoRecordsTemplate>
    <app-grid-no-records [loading]="loading" loadingText="Benutzer werden geladen…" i18n-loadingText></app-grid-no-records>
  </ng-template>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
  </ng-template>
  <kendo-grid-column field="firstName" i18n-title title="Vorname" [width]="100"></kendo-grid-column>
  <kendo-grid-column field="lastName" i18n-title title="Nachname" [width]="150"></kendo-grid-column>
  <kendo-grid-column field="email" i18n-title title="E-Mail" [width]="150"></kendo-grid-column>
  <kendo-grid-column
    field="securityCodeExpirationDate"
    i18n-title
    title="Gültig bis"
    format="{0:g}"
    [width]="120"
  ></kendo-grid-column>
  <kendo-grid-column i18n-title title="Status" [width]="110">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span
        class="badge"
        [class.bg-danger]="dataItem.isExpired"
        [class.bg-success]="!dataItem.isExpired"
      >{{ dataItem.isExpired ? expiredLabel : validLabel }}</span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column i18n-title title="E-Mail erneut senden" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="text-center">
        <button type="button" class="btn btn-sm btn-outline-secondary" title="E-Mail erneut senden" aria-label="E-Mail erneut senden" i18n-title i18n-aria-label [asyncClick]="onResendConfirmationEMail(dataItem.subject)" [disabled]="resendBtn.disabled" #resendBtn="asyncClick">
          <i>
            @if (resendBtn.busy) { <span class="spinner-border spinner-border-sm"></span> } @else {
            <fa-icon [icon]="faEnvelope"></fa-icon>
            }
          </i>
        </button>
      </div>
    </ng-template>
  </kendo-grid-command-column>

  <kendo-grid-command-column i18n-title title="Löschen" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="text-center">
                <button type="button" class="btn btn-sm btn-outline-danger" title="Löschen" aria-label="Löschen" i18n-title i18n-aria-label [asyncClick]="onDelete(dataItem.subject)" [disabled]="delBtn.disabled" #delBtn="asyncClick">
                    @if (delBtn.busy) { <span class="spinner-border spinner-border-sm"></span> } @else {
                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                    }
                </button>
            </div>
        </ng-template>
    </kendo-grid-command-column>

  <kendo-grid-pdf appGridPdf fileName="OffeneRegistrierungsanfragen.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.75">
    <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
    <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
      <app-pdf-page title="Registrierungen" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
    </ng-template>
  </kendo-grid-pdf>
</kendo-grid>
